import template from './bot-session-details.html';
import controller from './bot-session-details.controller';
import './bot-session-details.styl';

let botSessionDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default botSessionDetailsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/bot-session-details/bot-session-details.component.js
 **/